import { Theme } from '@mui/material/styles';

export const footerStyles = (theme: Theme, isDark: boolean) => ({
  container: {
    p: 'inherit',
    bottom: 0,
    position: 'relative',
    width: '100%',
    px: 10,
    pb: 4,
    pt: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      px: 5
    },
    [theme.breakpoints.down('md')]: {
      px: 4
    }
  },
  socialButton: {
    backgroundColor: isDark ? '#0B091F' : 'rgb(233, 240, 253)',
    boxShadow: isDark
      ? '0px 8px 12px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.05)'
      : '0px 0px 0px 1px rgba(21, 21, 31, 0.00), 0px 8px 28px rgba(22, 22, 26, 0.08)',
    backdropFilter: 'blur(40px)',
    backgroundBlendMode: 'overlay',
    p: 1,
    borderRadius: '20px',
    width: 28,
    height: 28,
    [theme.breakpoints.down('md')]: {
      width: 22,
      height: 22
    },
    color: theme.palette.primary.main,
    mr: 1,
    transition: 'opacity .3s',
    '& svg': {
      width: 18,
      height: 18,
      color: isDark ? '#fff' : '#000',
      [theme.breakpoints.down('md')]: {
        width: 16,
        height: 16
      },
      '&:hover': {
        opacity: 0.5
      }
    }
  },
  copyright: {
    fontVariationSettings: "'wght' 400"
  },
  copyrightSeparator: {
    fontVariationSettings: "'wght' 400",
    px: 1.5
  },
  discordText: {
    fontVariationSettings: "'wght' 500"
  },
  discordContainer: {
    textDecoration: 'none',
    '&:hover': {
      '& .MuiTypography-root': {
        color: isDark ? '#fff' : theme.palette.primary.main
      },
      cursor: 'pointer'
    }
  },
  copyrightAndTerms: {
    [theme.breakpoints.down('sm')]: {
      pb: 0.75
    }
  },
  termsAndConditions: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
      '& .MuiTypography-root': {
        color: isDark ? '#fff' : theme.palette.primary.main
      }
    }
  }
});
